// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_mz-0";